import { useRef } from "react";
import { TextInput, PasswordInput, Select } from "@mantine/core";
import Container from "../common/Container";
import { useForm } from "@mantine/form";
import PageHeader from "../common/PageHeader";
import { updateHrUserById } from "../../api/hrUserApi";
import { updateNotification } from "../../utils/useNotification";
import {
  combineValidators,
  validateMaxLength,
  validateMinLength,
  validateNoSpaces,
  validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero,
  validateRequired,
} from "../../utils/validations";
import { useNavigate, useParams, useLocation } from "react-router";
import { denormalizePhone } from "../../utils/phoneUtils";


const PanelUserUpdatePage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);

  const user = location.state?.panelUser;

  const form = useForm({
    initialValues: {
      name: user?.name || "",
      phone: denormalizePhone(user?.phone || ""),
      privilege: user?.privilege || null,
      password: "",
    },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired,
        validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric,
        validateNoSpaces,
        validateMinLength(11)
      ),
      privilege: (value: any) => (value ? null : "Bu alan zorunludur"),
      password: (value: any) =>
        value
          ? combineValidators(validateMaxLength(16), validateMinLength(4))(value)
          : null,
    },
  });

  const handleSubmit = async (values: any) => {
    try {
      const updates: any = { ...values };
      if (!updates.password) {
        delete updates.password;
      }
      const { data }: any = await updateHrUserById({
        id: id || user?._id,
        updates,
      });
      updateNotification(data?.success);
      if (data?.success) {
        navigate(-1);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Panel Kullanıcısı Bilgisi Düzenleme"
        isButtoned
        buttonText="Güncelle"
        buttonOnClick={() => formRef.current?.requestSubmit()}
        buttonDisabled={!form.isDirty()}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
          width: "min-content",
        }}
      >
        <form
          ref={formRef}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            width: "468px",
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <TextInput
            label="Ad Soyad"
            placeholder="Ad Soyad Giriniz."
            radius={10}
            size="md"
            maxLength={40}
            {...form.getInputProps("name")}
          />
          <TextInput
            label="Telefon"
            placeholder="05*********"
            radius={10}
            size="md"
            maxLength={11}
            {...form.getInputProps("phone")}
          />
          <Select
            label="Yetki"
            placeholder="Yetki Seçiniz"
            radius={10}
            size="md"
            data={[
              { value: "admin", label: "Admin" },
              { value: "user", label: "User" },
            ]}
            {...form.getInputProps("privilege")}
            value={form.values.privilege || null}
          />
          <PasswordInput
            label="Şifre (Değiştirmek için yeni şifre girin)"
            placeholder="Yeni şifre girin"
            radius={10}
            size="md"
            maxLength={16}
            {...form.getInputProps("password")}
          />
        </form>
      </div>
    </Container>
  );
};

export default PanelUserUpdatePage;
